import { render, staticRenderFns } from "./printPriceLabel.vue?vue&type=template&id=166d6c66&scoped=true&"
import script from "./printPriceLabel.vue?vue&type=script&lang=js&"
export * from "./printPriceLabel.vue?vue&type=script&lang=js&"
import style0 from "./printPriceLabel.vue?vue&type=style&index=0&id=166d6c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d6c66",
  null
  
)

export default component.exports